import Terceiro from "./Terceiro";

export default Terceiro;